import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-preparation-list',
    templateUrl: './preparation-list.component.html',
    styleUrls: ['./preparation-list.component.css'],
    standalone: false
})
export class PreparationListComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
